// React
import DataTable, { defaultThemes } from "react-data-table-component";
import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import PropTypes from "prop-types";

// Componentes y utils generales
import { mensajeSimple, detalleContratosEnviados, modalAprobarRechazarContrato, modalCargando, ModalEnviandoContratos, detalleContratos } from "../../../components/ui/sweetAlerts";
import { paginationComponentOptions, objStyleCol } from "../../../utils/Constants";
import Spinner from "../../../components/ui/Spinner";
import { Icono } from "../../../components/ui/Iconos";

// Apis
import { get, getUno, postWithResponse } from "../../../api/apis";

function capitalizeWords(text) {
  return text
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const DocumentoCell = ({ row, onMostrarPDF }) => (
  <button onClick={() => onMostrarPDF(row.id)} className="btn px-1 btn-danger border-0 btn-sm">
    <Icono iconName="pdf" />
  </button>
);

DocumentoCell.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  }).isRequired,
  onMostrarPDF: PropTypes.func.isRequired,
};

const Contrato = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [contratosArray, setContratosArray] = useState([]);
  const [totalRows, setTotalRows] = useState(null);
  const [perPage, setPerPage] = useState(10);
  const [pageTable, setPageTable] = useState(1);
  const [count, setCount] = useState(0);
  const [contratoName, setContratoName] = useState("");
  const [infoContrato, setInfoContrato] = useState("");
  const [visibleModal, setVisibleModal] = useState(false);
  const [lenght, setLenght] = useState(0);

  useEffect(() => {
    llamarPagina();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mostrarPDF = async id => {
    modalCargando(`Cargando documento...`);
    let strBase64 = "";
    const resp = await getUno("revisarcontrato", { idContrato: id });

    if (resp.data && resp.status === 200) {
      strBase64 = resp.data.Binario;
      mensajeSimple("success", "Documento cargado con éxito", 2000);
    }

    window.open(strBase64, "_blank");
  };

  const documentoCelda = (row) => <DocumentoCell row={row} onMostrarPDF={mostrarPDF} />

  const columnas = {
    admin: [
      {
        name: "ID lote",
        sortable: false,
        selector: row => row.IdLote,
        style: objStyleCol,
      },
      {
        name: "N° personal",
        sortable: false,
        selector: row => row.NPersonal,
        width: "90px",
        style: objStyleCol,
      },
      {
        name: "Nombre colaborador",
        sortable: false,
        selector: row => capitalizeWords(row.Nombre),
        wrap: true,
        width: "330px",
      },
      {
        name: "Rut",
        sortable: false,
        selector: row => row.Rut,
        width: "98px",
        style: objStyleCol,
      },
      {
        name: "División",
        sortable: false,
        selector: row => row.Division,
        width: "80px",
        style: objStyleCol,
      },
      {
        name: "Unidad organizativa",
        sortable: false,
        selector: row => row.TextoUnidadOrganizativa,
        wrap: true,
        width: "360px",
      },
      {
        name: "Subdivisión",
        sortable: false,
        selector: row => row.Subdivision,
        wrap: true,
        width: "100px",
        style: objStyleCol,
      },
      {
        name: "Cargo",
        sortable: false,
        selector: row => row.Cargo,
        wrap: true,
        width: "250px",
      },
      {
        name: "Fecha ingreso",
        sortable: false,
        selector: row => row.FechaIngreso.replaceAll(".", "-"),
        wrap: false,
        width: "90px",
        style: objStyleCol,
      },
      {
        name: "Fecha fin contrato",
        sortable: false,
        selector: row => row.FechaFinContrato.replaceAll(".", "-"),
        wrap: false,
        width: "90px",
        style: objStyleCol,
      },
      {
        name: "Horario",
        sortable: false,
        selector: row => row.Phtd,
        wrap: true,
        width: "90px",
      },
      {
        name: "Analista",
        sortable: false,
        selector: row => row.UsuarioSapEmisor,
        wrap: true,
        width: "140px",
      },
      {
        name: "Fecha de emisión",
        sortable: false,
        selector: row => row.FechaEmisionContrato.replaceAll(".", "-"),
        wrap: false,
        width: "90px",
        style: objStyleCol,
      },
      {
        name: "Plantilla utilizada",
        sortable: false,
        selector: row => row.NombrePlantilla,
        wrap: true,
        width: "250px",
      },
      {
        name: "Documento",
        cell: row => documentoCelda(row),
        style: {
          display: "flex",
          justifyContent: "center",
        },
      },
    ],
    rrhh: [
      {
        name: "N° personal",
        sortable: false,
        selector: row => row.NPersonal,
        width: "85px",
        style: objStyleCol,
      },
      {
        name: "Nombre colaborador",
        sortable: false,
        selector: row => capitalizeWords(row.Nombre),
        wrap: true,
        minWidth: "300px",
      },
      {
        name: "Rut",
        sortable: false,
        selector: row => row.Rut,
        width: "100px",
        style: objStyleCol,
      },
      {
        name: "Unidad organizativa",
        sortable: false,
        wrap: true,
        selector: row => row.TextoUnidadOrganizativa,
        minWidth: "140px",
      },
      {
        name: "Cargo",
        sortable: false,
        selector: row => row.Cargo,
        wrap: true,
        width: "150px",
      },
      // inicio nuevo contenido para el administrador
      {
        name: "Plantilla",
        sortable: false,
        selector: row => row.NombrePlantilla,
        wrap: true,
        width: "250px",
      },
      // fin nuevo contenido para el adminstrador
      {
        name: "Fecha ingreso",
        selector: row => row.FechaIngreso.replaceAll(".", "-"),
        wrap: true,
        width: "90px",
        style: objStyleCol,
      },
      {
        name: "Fecha fin contrato",
        selector: row => row.FechaFinContrato.replaceAll(".", "-"),
        wrap: false,
        width: "90px",
        style: objStyleCol,
      },
      {
        name: "Documento",
        cell: row => documentoCelda(row),
        style: {
          display: "flex",
          justifyContent: "center",
        },
      },
    ],
  };

  const seleccionarContrato = obj => {
    let arr = [];
    const checks = document.querySelectorAll('.rdt_TableBody input[type="checkbox"]');
    checks.forEach((el, idx) => {
      if (el.checked) {
        arr.push(data[idx]);
      }
    });
    setContratosArray(arr);
  };

  const borrarChecks = () => {
    if (!document.getElementsByName("select-all-rows")[0]?.checked) {
      document.getElementsByName("select-all-rows")[0]?.click();
    }
    document.getElementsByName("select-all-rows")[0]?.click();
    setContratosArray([]);
  };

  const llamarPagina = async (page = 1, per_page = 10) => {
    setLoading(true);
    borrarChecks();
    const resp = await get(`monitor?page=${page}&per_page=${per_page}`, null, null);
    setLoading(false);

    if (resp === 500) {
      mensajeSimple("error", "La sesión ha caducado.", 3000);
      return;
    }

    if (resp?.data) {
      if (resp.data.status === "info") {
        setData([]);
      } else if (resp.data.success) {
        const { data, total } = resp.data.data;
        setData(data);
        setTotalRows(total);
      }
    } else {
      setData([]);
    }
  };

  const getPerfil = (idPerfil, columnas) => {
    if (idPerfil === "3") {
      return columnas.rrhh;
    } else if (idPerfil === "4") {
      return columnas.admin;
    } else {
      return columnas.admin;
    }
  };

  const handlePageChange = page => {
    setPageTable(page);
    const el = document.getElementsByName("select-all-rows")[0];

    if (el.checked) {
      const ev = new Event("click", { bubbles: true });
      el.dispatchEvent(ev);
    }
    llamarPagina(page, perPage);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    setPerPage(newPerPage);
    llamarPagina(page, newPerPage);
  };

  const resolucionContrato = async obj => {
    setVisibleModal(true);
    setLenght(obj.idContrato.length);
    setCount(0);
    //aca
    modalCargando(`Enviando documentos...`);

    const arr = obj.idContrato.map(i => i.id);

    // Cambiado a postWithResponse para obtener el body JSON del error HTTP 400
    const resp = await postWithResponse("revisarcontrato", {}, { idContrato: arr, respuesta: obj.respuesta, motivo: obj.motivo, idPersona: jwtDecode(localStorage.getItem("token")).id_usuario_sap });

    console.log(resp);
    setCount(obj.idContrato.length);
    setVisibleModal(false);

    if (!resp?.data) {
      detalleContratos("error", "Ha ocurrido un problema de conexión.", "", llamarPagina);
      setContratoName(() => setContratoName(""));
      setInfoContrato(() => setInfoContrato(""));
      return;
    }

    const { status, message, data: responseData, errors } = resp.data;

    if (status === "success" && !errors) {
      if (responseData && responseData.length > 0 && responseData[0].data) {
        detalleContratosEnviados(status, message, responseData[0].data, llamarPagina, errors);
      } else {
        mensajeSimple("success", message || "Procesado con éxito", 4000);
        llamarPagina();
      }
    } else if (status === "success" && errors) {
      if (responseData && responseData.length > 0 && responseData[0].data) {
        detalleContratosEnviados("warning", message, responseData[0].data, llamarPagina, errors);
      } else {
        detalleContratos("warning", message, responseData || "", llamarPagina);
      }
    } else if (status === "info") {
      detalleContratos("info", message, responseData || "", llamarPagina);
    } else {
      detalleContratos("error", message || "Ha ocurrido un problema!", responseData || "", llamarPagina);
    }
    setContratoName(() => setContratoName(""));
    setInfoContrato(() => setInfoContrato(""));
  };

  const customStyles = {
    tableBody: {
      style: {
        borderLeftStyle: "solid",
        borderLeftWidth: "1px",
        borderLeftColor: defaultThemes.default.divider.default,
      },
    },
    header: {
      style: {
        minHeight: "40px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: defaultThemes.default.divider.default,
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
        marginLeft: "2px",
        marginRight: "2px",
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
        marginLeft: "2px",
        marginRight: "2px",
      },
    },
    responsiveWrapper: {
      style: {
        border: `1px solid ${defaultThemes.default.divider.default}`,
      },
    },
  };

  return (
    <>
      <div className="row">
        <div className="col-sm-12 ">
          <div className="card-header bgArcopime h5 py-1">Documentos a revisar</div>
          <div className="card cardPestania">
            <ModalEnviandoContratos actual={count} max={lenght} contratoName={contratoName} infoContrato={infoContrato} visibleModal={visibleModal} />
            {loading ? (
              <Spinner />
            ) : (
              <div className="card-body contenedorTabla">
                {data.length > 0 ? (
                  <DataTable
                    title={false}
                    responsive={true}
                    columns={getPerfil(localStorage.getItem("id_perfil"), columnas)}
                    data={data}
                    progressPending={loading}
                    pagination
                    paginationDefaultPage={pageTable}
                    paginationPerPage={perPage}
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    paginationServer={true}
                    paginationComponentOptions={paginationComponentOptions}
                    selectableRows
                    customStyles={customStyles}
                    onSelectedRowsChange={seleccionarContrato}
                    dense
                    fixedHeader
                    fixedHeaderScrollHeight="440px"
                  />
                ) : (
                  <p className="h5 text-center my-3 titleMensajeSimple">No se encontraron registros</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {contratosArray.length > 0 && (
        <div className="row mt-3">
          <div className="col-sm-12">
            <button onClick={() => modalAprobarRechazarContrato(contratosArray, resolucionContrato)} className="ms-0 pe-2 btnCopec">
              Revisar contrato{contratosArray.length > 1 ? "s" : ""}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Contrato;
